import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { SOLUTIONS } from '../data/mock';
import { CheckCircle2, ArrowRight, ShoppingBag, GraduationCap, Home as HomeIcon, HeartPulse, Plane, Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import CTA from '../components/CTA';

const ICONS = {
  ecommerce: ShoppingBag,
  education: GraduationCap,
  realestate: HomeIcon,
  healthcare: HeartPulse,
  travel: Plane,
  agency: Building2,
};

export default function Solutions() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <section className="section-fade pt-16 pb-8">
        <div className="max-w-4xl mx-auto text-center px-5 lg:px-8">
          <p className="chip mb-4">Solutions</p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900">
            Built for every industry
          </h1>
          <p className="mt-5 text-slate-600 text-lg">
            Whatever business you run, ACTIWA has a proven playbook to help you grow on WhatsApp.
          </p>
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SOLUTIONS.map((s) => {
            const Icon = ICONS[s.id] || Building2;
            return (
              <div key={s.id} id={s.id} className="bg-white border border-slate-200 rounded-2xl p-7 card-lift">
                <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 grid place-items-center">
                  <Icon size={22} />
                </div>
                <h3 className="mt-4 text-xl font-bold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <ul className="mt-4 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                      <CheckCircle2 size={16} className="text-emerald-500 mt-0.5 shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
                <Link to="/demo" className="inline-block mt-5">
                  <Button variant="outline" size="sm" className="rounded-full">
                    Explore <ArrowRight size={14} className="ml-1" />
                  </Button>
                </Link>
              </div>
            );
          })}
        </div>
      </section>

      <CTA />
    </>
  );
}
